import { useRequest } from '@10000/react'
import { InputScreen, onboardBackground, useBackground, useShell } from '../../layout'
import { Body, Box, H3 } from '../../widgets'
import { assetUrl } from '../../../utilities.js'

export const OnboardConfirmation = ({ active }) => {
  const request = useRequest('tenant')
  useShell({ active, mode: 'narrow logo' })
  useBackground().set(mobile => ({ active, fade: false, ...onboardBackground(false, mobile) }))

  return (
    <InputScreen
      footerButton="Go to your homepage"
      onSubmit={() => request('teamSetupComplete')}
    >
      <Box position="absolute" inset background={`var(--black-fade), url(${assetUrl('gifs/confetti.gif')}) center / 900px 1200px, var(--blue)`} />

      <Box column gap={24} zIndex={1}>
        <Box column gap={8} alignItems="center">
          <Box radius="50%" height={120} width={120} aspect="1/1" overflow="hidden">
            <video src={assetUrl('videos/morphing-shapes.mp4')} autoPlay muted loop/>
          </Box>
          <H3>You are all set!</H3>
          <Body align="center">
            It&apos;s time to shine! Let&apos;s shivoo and see how your team compares.
          </Body>
        </Box>
      </Box>
    </InputScreen>
  )
}